export default {
  // 获取产品列表
  GET_LIST: '/jcnapi/department/getList',
  DEL: '/jcnapi/department/delete',
  //保存
  SAVE: '/jcnapi/department/save'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/business/index.js